import { useQuery } from '@tanstack/react-query';
import { getModulesWithPermissions } from '@/services/roleService';

export function useModulesWithPermissions(options?: { enabled?: boolean }) {
  return useQuery({
    queryKey: ['modulesWithPermissions'],
    queryFn: getModulesWithPermissions,
    enabled: options?.enabled ?? true,
  });
}
